import controller from './query-columns.controller';
import template from './query-columns.html';
import './query-columns.scss';

export default {
	controller,
	template,
	bindings: {
		columns:  '<ngModel',
		root:  '<',
		options:  '<?',
		classRepresentations:  '<?',
	},
	require:  {
		ngModelCtrl: '?ngModel',
	},
};
